<script setup>
import Icon from '@/Components/Icon/index.vue';
import Heading from '@/Components/Heading.vue';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';


const props = defineProps({
  course: {
    type: Object,
    required: true,
  }
});

const page = usePage();
const context = computed(() => page.props?.context);

const courseSite = computed(() => {
  if(!props.course.sites.length){
    return null;
  }
  let sites = props.course.sites;

  if (context.value.search_filters?.all_scoped_states) {
    sites = sites.filter((site) => 
      context.value.search_filters.all_scoped_states.includes(site.state)
    );
  }
  
  return sites[0];  
});

const courseSiteLocale = computed(() => {
  const { region, state, country } = courseSite.value ?? {};

  return region?.name || state?.toUpperCase() || country?.name || null;
});
</script>

<template>
  <div>
    <p class="ext-sm mb-2 flex align-items-center">The course you're interested in is</p>
    <Heading
      size="h3"
      style-size="h3"
      class="mb-2"
    >
      <strong><a
        :href="`/course/${course.slug}/${course.id}`"
        class="border-none"
      >{{ course.name }}</a></strong>
    </Heading>
    <p
        v-if="courseSiteLocale"
      class="text-sm flex align-items-center mb-2"
    >
      <Icon
        class="me-2"
        path="University"
        :height="16"
        :width="16"
      />
      <a
        tabindex="-1"
        class="ms-2 text-sm"
        :href="`/course/${course.slug}/${course.id}`"
      >
        {{ courseSiteLocale }} 
        <template v-if="course.sites.length && course.sites.length > 1">
          + {{ `${course.sites.length - 1}  other ${course.sites.length > 2 ? 'campuses' : 'campus'}` }}
        </template>
      </a>
    </p>
  </div>
</template>
